export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7392.d53a259a.jpg";